import ViewerCountWidget from '../../widgets/ViewerCountWidget';
import FetchPoller from '../../FetchPoller';
import { tryFetch } from '../../widgetLoader';
import { loadWidgetData, RELOAD_INTERVAL } from './common';

export default async function mountViewerCount(host) {
	const widget = new ViewerCountWidget({ container: host.container });
	await widget.init(await loadWidgetData(host, []));

	const hash = encodeURIComponent(host.hash);
	const channelInfoPollers = new Map();

	async function fetchChannels(signal) {
		const channels = await tryFetch(() => host.api.get(`widget/${hash}/channels`, {}, signal), `cache-${host.hash}-channels`);
		const list = channels || [];
		widget.setChannels(list);

		const enabledKeys = new Set(list.filter(c => c.status === 'enabled').map(c => `${c.service_id}:${c.token}`));

		for(const [ key, poller ] of channelInfoPollers) {
			if(!enabledKeys.has(key)) { poller.stop(); channelInfoPollers.delete(key); }
		}

		for(const c of list) {
			if(c.status !== 'enabled') continue;
			const key = `${c.service_id}:${c.token}`;
			if(channelInfoPollers.has(key)) continue;
			const poller = new FetchPoller(sig =>
				host.api.get(`widget/${hash}/channels/${encodeURIComponent(c.service_id)}/${encodeURIComponent(c.token)}/info`, {}, sig)
					.then(info => widget.setChannelInfo(c.service_id, c.token, info))
					.catch(err => console.error('Channel info polling error', err)),
				60 * 1000,
			);
			channelInfoPollers.set(key, poller);
			poller.start();
		}
	}

	const channelPoller = new FetchPoller(fetchChannels, 5 * 60 * 1000);
	channelPoller.start();

	host.onSettingsChange(s => {
		widget.applySettings(s);
		channelPoller.start();
	});

	async function reload() {
		widget.applySettings(await host.loadSettings());
		channelPoller.start();
	}

	host.subscribe({
		reconnect: reload,
		channelInfoUpdate: msg => {
			widget.setChannelInfo(msg.serviceId, msg.channelToken, { numViewers: msg.numViewers, numViews: msg.numViews, numLive: msg.numLive });
		},
		channelCreated: () => channelPoller.start(),
		channelDeleted: () => channelPoller.start(),
		channelStatusChanged: () => channelPoller.start(),
	});

	host.every(reload, RELOAD_INTERVAL);
	host.onDestroy(() => {
		channelPoller.stop();
		for(const poller of channelInfoPollers.values()) poller.stop();
		widget.destroy();
	});
}
